/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsList } from "../../funcs/accountsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1AccountsListRequest$inboundSchema,
};

export const tool$accountsList: ToolDefinition<typeof args> = {
  name: "accounts_list",
  description: `List all accounts

Retrieves a list of accounts`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountsList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
